import {
  TTranslationAppearanceForm,
} from '@/page/general-settings/appearance/appearance.ts';

const appearanceForm: TTranslationAppearanceForm = {
  locale: {
    label: 'Język',
    tooltip: 'Pozwala wybrać żądany język i ustawienia regionalne interfejsu użytkownika.',
  },
  fontSize: {
    label: 'Skalowanie strony',
    tooltip: 'Pozwala doZastosuj rozmiar czcionki i elementu interfejsu użytkownika.',
  },
  chartTimeFormat: {
    label: 'Format czasu wykresu',
    tooltip: 'Określa sposób wyświetlania dat i znaczników czasu na osi X wykresów.',
  },
  unitSystem: {
    label: 'System jednostek',
    tooltip: 'Wybierz preferowane jednostki miary (np. metryczne lub imperialne) do wyświetlania wartości',
  },
  scaleOption: {
    label: 'Skalowanie układu',
    tooltip: 'Określa sposób wyświetlania skalowania układu sklepu.',
  },
  showOnlyAvailableApps: {
    label: 'Ukryć nieaktywne aplikacje?',
    tooltip: 'Ukrywa aplikacje, które nie są dostępne, aby interfejs użytkownika był bardziej przejrzysty.',
  },
};

export default {
  subline: 'Zmień wygląd i odczucia Qmulusa',
  appearanceForm,
};
